var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',[_c('div',{staticClass:"footer-text"},[_c('p',[_vm._v("© 2020 All Rights Reserved ")])])])])
}]

export { render, staticRenderFns }